import React, { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { trackTraceException } from "services/trackInsights";
import { getChecklist, postChecklist, vaEcDownloads } from "services/va";
import {
  modules as modulesPre,
  texts as textsPre,
  TYPES
} from "pages/va/guiaVistoria/main/components/homeGuiaList/functions";
import { useHistory, useLocation } from "react-router-dom";
import {
  ROUTES,
  STATUS_CHECKLIST_VA,
  STATUS_ITEM_CHECKLIST_VA
} from "utils/constants";
import ContractContext from "contexts/contract";
import { ModalError } from "components";
import AuthContext from "../auth";
import { obterDadosDoUsuario } from "../../utils/functions";

const SCOPE_LOCAL_STORAGE_KEY_CHECKLIST = "SCOPE_LOCAL_STORAGE_KEY_CHECKLIST";

const VAContext = React.createContext({
  loading: true,
  setLoading: () => {},
  loadChecklist: () => {},
  checklist: [],
  isLoaded: false,
  modules: [],
  texts: [],
  stateItems: {},
  updateStateItems: () => {},
  status: null,
  notApplyEnvironment: () => {},
  notApplyItem: () => {},
  notApplyCaracteristica: () => {},
  isRevistoria: false,
  doSaveToBack: () => {},
  setPostCommentGeneral: () => {},
  postCommentGeneral: null,
  notShowProgress: false,
  setNotShowProgress: () => {},
  isInLocation: false,
  setIsInLocation: () => {},
  selectedContract: null,
  canVistoria: false,
  unidadeId: null,
  statusNowTag: null,
  setStatusNowTag: () => {},
  extraParams: null,
  setExtraParams: () => {},
  vaEcDownload: () => {},
  vaEcDownloadData: null,
  ocorrenciaCRM: false,
  setOcorrenciaCRM: () => {},
  setChecklistByIdVistoria: () => {}
});

export const VAContextProvider = ({ children }) => {
  const { selectedContract, loading: loadingContract, load } = useContext(
    ContractContext
  );
  const { pathname } = useLocation();
  const history = useHistory();
  const { user } = useContext(AuthContext);

  const [loading, setLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [checklist, setChecklist] = useState({});
  const [modules, setModules] = useState(true);
  const [texts, setTexts] = useState(true);
  const [stateItems, setStateItems] = useState({});
  const [status, setStatus] = useState(null);
  const [isRevistoria, setIsRevistoria] = useState(null);
  const [postCommentGeneral, setPostCommentGeneral] = useState(null);
  const [notShowProgress, setNotShowProgress] = useState(false);
  const [isInLocation, setIsInLocation] = useState(false);

  useEffect(() => {
    if (user?.cohab) {
      setIsInLocation(true);
    }
  }, [user]);
  const [canVistoria, setCanVistoria] = useState(false);
  const [unidadeId, setUnidadeId] = useState(null);
  const [statusNowTag, setStatusNowTag] = useState(null);
  const [extraParams, setExtraParams] = useState(null);
  const [canShowError, setCanShowError] = useState(false);
  const [retryCounts, setRetryCounts] = useState(0);
  const [vaEcDownloadData, setVaEcDownloadData] = useState(null);
  const [loadingVaEcDownload, setLoadingVaEcDownload] = useState(false);
  const [ocorrenciaCRM, setOcorrenciaCRM] = useState(false);
  const [isContingencia, setIsContingencia] = useState(false);

  useEffect(() => {
    if (pathname.indexOf(ROUTES.VISTORIA_ANTECIPADA_GENERAL) > -1) {
      setCanShowError(true);
    } else {
      setCanShowError(false);
    }
  }, [pathname]);

  useEffect(() => {
    if (user) {
      if (!user.isSoftauth) {
        if (!selectedContract.unidadeId && loadingContract) {
          load();
        }
      } else {
        setUnidadeId(user.unitId);
      }
    }
  }, [loadingContract, user]);

  useEffect(() => {
    if (user) {
      if (selectedContract.unidadeId && !user.isSoftauth) {
        setUnidadeId(selectedContract.unidadeId);
      }
    }
  }, [selectedContract, user]);

  const setLocalstorage = () => {
    localStorage.setItem(
      SCOPE_LOCAL_STORAGE_KEY_CHECKLIST,
      JSON.stringify(checklist)
    );
  };

  const notApplyEnvironment = (environmentName, state) => {
    setChecklist(checklistLocal => {
      checklistLocal.ambientes.forEach(ambiente => {
        if (ambiente.ambiente === environmentName) {
          ambiente.itens.forEach(item =>
            item.caracteristicas.forEach(caracteristica => {
              if (!(isRevistoria && !caracteristica.revistoria)) {
                caracteristica.status = state;
              }
            })
          );
        }
      });
      return { ...checklistLocal };
    });
    setLocalstorage();
  };

  const notApplyItem = (environmentName, itemParam, state) => {
    setChecklist(checklistParam => {
      checklistParam.ambientes.forEach(ambiente => {
        if (ambiente.ambiente === environmentName) {
          ambiente.itens.forEach(item => {
            if (item.tipo === itemParam.tipo) {
              item.caracteristicas.forEach(caracteristica => {
                if (!(isRevistoria && !caracteristica.revistoria)) {
                  caracteristica.status = state;
                }
              });
            }
          });
        }
      });
      return { ...checklistParam };
    });
    setLocalstorage();
  };

  const notApplyCaracteristica = (
    environmentName,
    itemParam,
    caracteristicaParam,
    state,
    postContent = null
  ) => {
    setChecklist(checklistLocal => {
      checklistLocal.ambientes.forEach(ambiente => {
        if (ambiente.ambiente === environmentName) {
          ambiente.itens.forEach(item => {
            if (item.tipo === itemParam) {
              item.caracteristicas.forEach(caracteristica => {
                if (!(isRevistoria && !caracteristica.revistoria)) {
                  if (caracteristica.id === caracteristicaParam.id) {
                    caracteristica.status = state;
                    if (postContent) {
                      caracteristica.comentarioExecutor = postContent;
                    }
                    if (state === STATUS_ITEM_CHECKLIST_VA.CONFORME) {
                      caracteristica.comentarioExecutor = "";
                    }
                  }
                }
              });
            }
          });
        }
      });
      return { ...checklistLocal };
    });
    setLocalstorage();
  };

  const countTotalCaracteristicas = () => {
    let count = 0;
    let countSomeState = 0;
    if (checklist && checklist.ambientes) {
      checklist.ambientes.forEach(ambiente => {
        ambiente.itens.forEach(item => {
          item.caracteristicas.forEach(caracteristica => {
            count += 1;
            if (
              caracteristica.status !==
              STATUS_ITEM_CHECKLIST_VA.PENDENTE_AVALIACAO
            ) {
              countSomeState += 1;
            }
          });
        });
      });
    }
    return { count, countSomeState };
  };

  useEffect(() => {
    if (pathname.indexOf(ROUTES.VISTORIA_ANTECIPADA_CHECKLIST) > -1) {
      const { count, countSomeState } = countTotalCaracteristicas();
      setStatus({
        steps: count,
        currentStep: countSomeState
      });
    } else if (pathname.indexOf(ROUTES.VISTORIA_ANTECIPADA_ENTRADA_ID) > -1) {
      setStatus({ steps: 0, currentStep: 0 });
    } else {
      setStatus(null);
    }
  }, [pathname, checklist, isRevistoria]);

  const makeChecklist = checklistParams => {
    const modulesF = [...modulesPre];
    const textsF = [...textsPre];

    let nextId = 1;
    let subModuleId = 1;
    checklistParams.ambientes.forEach(ambiente => {
      nextId += 1;
      modulesF[2].subModules.push({
        id: `${nextId}`,
        text: ambiente.ambiente
      });
      subModuleId += 1;
      const elementTextF = {
        moduleId: "3",
        subModuleId: `${subModuleId}`,
        content: [
          {
            type: TYPES.LIST,
            list: []
          }
        ],
        above: true
      };
      textsF.push(elementTextF);

      ambiente.itens.forEach(te => {
        nextId += 1;
        modulesF[2].subModules.push({
          id: `${nextId}`,
          text: `${ambiente.ambiente} - ${te.tipo}`,
          notShowInInitial: true
        });

        elementTextF.content[0].list.push({
          text: te.tipo,
          nextSubId: nextId,
          nextModuleId: "3"
        });

        subModuleId += 1;
        const elementTextF2 = {
          moduleId: "3",
          subModuleId: `${subModuleId}`,
          content: [
            {
              type: TYPES.LIST_DROPDOWN,
              list: []
            }
          ],
          above: true
        };

        te.caracteristicas.forEach(caracteristica => {
          elementTextF2.content[0].list.push({
            title: caracteristica.tipo,
            text: caracteristica.metodoVerificacao
          });
        });
        textsF.push(elementTextF2);
      });
    });
    setModules(modulesF);
    setTexts(textsF);
  };

  const adicionarImagemAsCaracteristicas = dadosModificados => {
    dadosModificados.checklist.forEach(ambiente => {
      ambiente.itens.forEach(item => {
        const imagemDoItem = item.imagem;
        if (item.caracteristicas && item.caracteristicas.length > 0) {
          item.caracteristicas.forEach(caracteristica => {
            caracteristica.imagem = imagemDoItem;
          });
        }
      });
    });
    return dadosModificados;
  };

  const loadChecklist = async () => {
    if (retryCounts > 1) {
      return;
    }

    setIsError(false);
    if (loading) return;
    try {
      setLoading(true);
      let checklistResponse;
      const localstorageChecklist = localStorage.getItem(
        SCOPE_LOCAL_STORAGE_KEY_CHECKLIST
      );
      if (localstorageChecklist) {
        try {
          checklistResponse = JSON.parse(localstorageChecklist);
        } catch (error) {
          localStorage.removeItem(SCOPE_LOCAL_STORAGE_KEY_CHECKLIST);
        }
      }
      let checklistResponseBack = (await getChecklist(unidadeId)).data;

      checklistResponseBack = adicionarImagemAsCaracteristicas(
        checklistResponseBack
      );

      checklistResponseBack = {
        ...checklistResponseBack,
        ambientes: checklistResponseBack.checklist
      };
      delete checklistResponseBack.checklist;

      if (checklistResponse) {
        if (
          checklistResponseBack.id === checklistResponse.id &&
          checklistResponseBack.status === checklistResponse.status
        ) {
          checklistResponseBack.ambientes = checklistResponse.ambientes;
        }
      }
      localStorage.setItem(
        SCOPE_LOCAL_STORAGE_KEY_CHECKLIST,
        JSON.stringify(checklistResponseBack)
      );
      setChecklist(checklistResponseBack);
      setIsRevistoria(
        checklistResponseBack.status ===
          STATUS_CHECKLIST_VA.AGUARDANDO_REVISTORIA
      );
      setCanVistoria(
        checklistResponseBack.status ===
          STATUS_CHECKLIST_VA.AGUARDANDO_REVISTORIA ||
          checklistResponseBack.status ===
            STATUS_CHECKLIST_VA.AGUARDANDO_VISTORIA
      );
      makeChecklist(checklistResponseBack);
      setIsLoaded(true);
    } catch (error) {
      setRetryCounts(retryCounts + 1);
      setIsError(true);
      trackTraceException("loadChecklist", error);
    } finally {
      setLoading(false);
    }
  };

  const setChecklistByIdVistoria = checklistData => {
    setIsContingencia(true);
    let checklistResponse;
    const localstorageChecklist = localStorage.getItem(
      SCOPE_LOCAL_STORAGE_KEY_CHECKLIST
    );
    if (localstorageChecklist) {
      try {
        checklistResponse = JSON.parse(localstorageChecklist);
      } catch (error) {
        localStorage.removeItem(SCOPE_LOCAL_STORAGE_KEY_CHECKLIST);
      }
    }
    let checklistResponseBack = adicionarImagemAsCaracteristicas(checklistData);
    checklistResponseBack = {
      ...checklistResponseBack,
      ambientes: checklistResponseBack.checklist
    };
    delete checklistResponseBack.checklist;

    if (checklistResponse) {
      if (
        checklistResponseBack.id === checklistResponse.id &&
        checklistResponseBack.status === checklistResponse.status
      ) {
        checklistResponseBack.ambientes = checklistResponse.ambientes;
      }
    }
    localStorage.setItem(
      SCOPE_LOCAL_STORAGE_KEY_CHECKLIST,
      JSON.stringify(checklistResponseBack)
    );
    setChecklist(checklistResponseBack);
    setIsRevistoria(
      checklistResponseBack.status === STATUS_CHECKLIST_VA.AGUARDANDO_REVISTORIA
    );
    setCanVistoria(
      checklistResponseBack.status ===
        STATUS_CHECKLIST_VA.AGUARDANDO_REVISTORIA ||
        checklistResponseBack.status === STATUS_CHECKLIST_VA.AGUARDANDO_VISTORIA
    );
    makeChecklist(checklistResponseBack);
    setIsLoaded(true);
  };

  const updateStateItems = (key, value) => {
    if (stateItems[key]) {
      setStateItems(state => ({
        ...state,
        [key]: { ...state[key], ...value }
      }));
    }
    setStateItems(state => ({ ...state, [key]: value }));
  };

  const doSaveToBack = async () => {
    const dataUser = await obterDadosDoUsuario();
    let responseToBack = checklist.ambientes.map(ambiente => {
      return ambiente.itens.map(item => {
        return item.caracteristicas.map(carac => {
          return {
            id: carac.id,
            comentarioExecutor: carac.comentarioExecutor,
            status:
              carac.status === STATUS_ITEM_CHECKLIST_VA.REPARO_NAO_AUTORIZADO
                ? STATUS_ITEM_CHECKLIST_VA.APROVADO_POR_NORMA
                : carac.status
          };
        });
      });
    });
    responseToBack = responseToBack.flat().flat();
    const returnBack = {
      id: checklist.id,
      localVistoriaId: checklist.localVistoriaId,
      ocorrenciaCRM: checklist.ocorrenciaCRM,
      itens: responseToBack,
      observacao: postCommentGeneral,
      contingencia: isContingencia,
      ambienteCliente: {
        navegador: dataUser.navegador,
        sistemaOperacional: dataUser.sistemaOperacional,
        ip: dataUser.ip
      }
    };

    if (user && user.isSoftauth) {
      returnBack.vistoriador = {
        nome: user.name,
        cpf: user.cpfCnpj,
        tipo: user.tipo
      };
    }
    return postChecklist(returnBack, unidadeId).then(_r => {
      return localStorage.removeItem(SCOPE_LOCAL_STORAGE_KEY_CHECKLIST);
    });
  };

  const vaEcDownload = () => {
    if (loadingVaEcDownload || vaEcDownloadData !== null) return true;
    setLoadingVaEcDownload(true);
    vaEcDownloads(unidadeId)
      .then(result => {
        if (result.laudoVA.disponivel) {
          setOcorrenciaCRM(result.laudoVA.numeroOcorrencia);
        } else if (result.laudoEC.disponivel) {
          setOcorrenciaCRM(result.laudoEC.numeroOcorrencia);
        }
        setVaEcDownloadData(result);
      })
      .catch(error => {
        trackTraceException("loadVaEcDownload", error);
        setVaEcDownloadData({});
      })
      .finally(() => {
        setLoadingVaEcDownload(false);
      });
  };

  const value = React.useMemo(
    () => ({
      loading,
      setLoading,
      checklist,
      loadChecklist,
      isLoaded,
      modules,
      texts,
      updateStateItems,
      stateItems,
      status,
      notApplyEnvironment,
      notApplyItem,
      notApplyCaracteristica,
      isRevistoria,
      doSaveToBack,
      postCommentGeneral,
      setPostCommentGeneral,
      notShowProgress,
      setNotShowProgress,
      isInLocation,
      setIsInLocation,
      selectedContract,
      canVistoria,
      unidadeId,
      statusNowTag,
      setStatusNowTag,
      extraParams,
      setExtraParams,
      vaEcDownload,
      vaEcDownloadData,
      ocorrenciaCRM,
      setOcorrenciaCRM,
      setChecklistByIdVistoria
    }),
    [
      loading,
      setLoading,
      checklist,
      loadChecklist,
      isLoaded,
      modules,
      texts,
      updateStateItems,
      stateItems,
      status,
      notApplyEnvironment,
      notApplyItem,
      notApplyCaracteristica,
      isRevistoria,
      doSaveToBack,
      postCommentGeneral,
      setPostCommentGeneral,
      notShowProgress,
      setNotShowProgress,
      isInLocation,
      setIsInLocation,
      selectedContract,
      canVistoria,
      unidadeId,
      statusNowTag,
      setStatusNowTag,
      extraParams,
      setExtraParams,
      vaEcDownload,
      vaEcDownloadData,
      ocorrenciaCRM,
      setOcorrenciaCRM,
      setChecklistByIdVistoria
    ]
  );

  return (
    <VAContext.Provider value={value}>
      {children}
      <ModalError
        open={isError && canShowError}
        onButtonClick={() => {
          setIsError(false);
          history.replace(ROUTES.HOME);
        }}
        message="Erro ao carregar o checklist. Tente novamente mais tarde."
        buttonName="Sair"
      />
    </VAContext.Provider>
  );
};

VAContextProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export default VAContext;
